<div
    class="portfolio-info pointer"
    (click)="selectRegularWithdrawalInvestment(regularWithdrawalInvestment.regularWithdrawalId)"
    (keydown.space)="selectRegularWithdrawalInvestment(regularWithdrawalInvestment.regularWithdrawalId)"
    (keydown.enter)="selectRegularWithdrawalInvestment(regularWithdrawalInvestment.regularWithdrawalId)"
    tabindex="0"
>
    <liberro-avatar-photo-tagged
        size="44"
        [portfolioDetail]="avatarInput()"
    ></liberro-avatar-photo-tagged>
    <div class="portfolio-preview">
        <div class="portfolio-name">
            {{ regularWithdrawalInvestment.portfolioName }}
        </div>
        <div class="portfolio-frequency">
            {{ regularWithdrawalFrequencyMap!.get(regularWithdrawalInvestment.frequency)! | translate }}
        </div>

    </div>
    <div class="portfolio-stats">
        <div class="portfolio-value">
            {{ regularWithdrawalInvestment.value | price: 'CZK'}}
        </div>
        <div class="portfolio-changes">
            {{ regularWithdrawalInvestment.nextExecutionDate ? (regularWithdrawalInvestment.nextExecutionDate | date: 'd. M. yyyy') : '-' }}
        </div>
    </div>
</div>
